<template>
    <div class="container" :style="{'overflow-y':!showAnimations?'auto':'hidden','height':'100%'}">
        <div class="head">
            <maijia-head></maijia-head>
            <div class="head_content">
                <p>{{$t('maijia.headText0')}}</p>
                <p>『{{$t('maijia.headText1')}}』</p>
                <p>{{$t('maijia.headText2')}}</p>
                <p>{{$t('maijia.headText3')}}</p>
                <p>『{{$t('maijia.headText4')}}』</p>
                <p>{{$t('maijia.headText5')}}<br />
                    {{$t('maijia.headText6')}}</p>
                <a class="down_arrow" href="#serve"></a>
            </div>
            <div class="head_animation" v-if="showAnimations">
                <img class="head_animation_logo" v-if="showLogo" :class="{'animations_opacity':animations==1,'animations_logo':animations==2}" src="../assets/images/maijia_logo_start.png" alt="">
                <div class="head_animation_left" :class="{'animations_door':animations==3}"></div>
                <div class="head_animation_line" :class="{'animations_line':animations==2}"></div>
                <div class="head_animation_right" :class="{'animations_door':animations==3}"></div>
            </div>
        </div>
        <div class="bgc_w d_f_c_c" id="serve" style="padding:128px 0;">
            <p style="font-size: 30px;color: #000000;">{{$t('maijia.serveTitle')}}</p>
            <p style="font-size: 20px;color: #333333;padding:20px 0 60px;">{{$t('maijia.serveIllustrate')}}</p>
            <div class="serve_box">
                <div class="p_r" style="width:380px;height:322px;margin:0 30px 30px 0;">
                    <el-image class="p_a" :class="{'animations_serve_image':serveImageLoad['0']==true}" @load="handleImageLoad(0)" src="https://wxgroup-img.duomai.com/7796da2bc9fcf195b2afb8dc79572b14" lazy></el-image>
                    <p>{{$t('maijia.serveTitle1')}}</p>
                    <p>{{$t('maijia.serveDetail1')}}</p>
                    <div></div>
                </div>
                <div class="p_r" style="width:380px;height:322px;margin:0 30px 30px 0;">
                    <el-image class="p_a" :class="{'animations_serve_image':serveImageLoad['1']==true}" @load="handleImageLoad(1)" src="https://wxgroup-img.duomai.com/bebe5fd330330fe4735c68e10b507735" lazy></el-image>
                    <p>{{$t('maijia.serveTitle2')}}</p>
                    <p>{{$t('maijia.serveDetail2')}} ”</p>
                    <div></div>
                </div>
                <div class="p_r" style="width:380px;height:322px;">
                    <el-image class="p_a" :class="{'animations_serve_image':serveImageLoad['2']==true}" @load="handleImageLoad(2)" src="https://wxgroup-img.duomai.com/c88402e1e66cfed0e2ca83e3f9562f2b" lazy></el-image>
                    <p>{{$t('maijia.serveTitle3')}}</p>
                    <p>{{$t('maijia.serveDetail3')}}</p>
                    <div></div>
                </div>
                <div class="p_r" style="width:790px;height:322px;margin-right:30px;">
                    <el-image class="p_a" :class="{'animations_serve_image':serveImageLoad['3']==true}" @load="handleImageLoad(3)" src="https://wxgroup-img.duomai.com/0233d0769899fb73ebc16ba791783c5c" lazy></el-image>
                    <p>{{$t('maijia.serveTitle4')}}</p>
                    <p>{{$t('maijia.serveDetail4')}}</p>
                    <div></div>
                </div>
                <div class="p_r" style="width:380px;height:322px;">
                    <el-image class="p_a" :class="{'animations_serve_image':serveImageLoad['4']==true}" @load="handleImageLoad(4)" src="https://wxgroup-img.duomai.com/a5455796496288f970a6462639d7a54c" lazy></el-image>
                    <p>{{$t('maijia.serveTitle5')}}</p>
                    <p>{{$t('maijia.serveDetail5')}}</p>
                    <div></div>
                </div>
            </div>
        </div>

        <div class="bgc_b d_f_c_c" style="padding:100px 0;">
            <p style="font-size: 30px;color: #FFFFFF;padding-bottom:60px;">{{$t('maijia.goodCase')}}</p>
            <div class="case_list">
                <case-items v-for="v in caseList" :key="v.NewsID" :data="v"></case-items>
            </div>
            <div class="case_more" @click="go" v-if="showCaseMore">
                {{$t('maijia.seeMore')}}
            </div>
        </div>

        <div class="bgc_w d_f_c_c" style="padding:100px 0;">
            <div style="width:1200px;">
                <p style="font-size: 30px;color: #000000;text-align: center;padding-bottom:40px;">{{$t('maijia.maijiaTitle')}}</p>
                <p style="font-size: 24px;color: #666666;line-height: 48px;">{{$t('maijia.maijiaText1')}}</p>
                <p style="font-size: 24px;color: #666666;line-height: 48px;padding:20px 0;">{{$t('maijia.maijiaText2')}}</p>
                <p style="font-size: 24px;color: #666666;line-height: 48px;">{{$t('maijia.maijiaText3')}}</p>
            </div>
        </div>

        <div class="contact d_f_c_c">
            <div class="contact_detail">
                <div class="contact_detail_left">
                    <p>{{$t('maijia.contactTitle')}}</p>
                    <p>{{$t('maijia.contactIllustrate')}}</p>
                    <input type="text" v-model="name" :placeholder="placeholderName">
                    <input type="text" v-model="contactWay" :placeholder="placeholderContactWay">
                    <div @click="handleSubmit">{{$t('maijia.submitBtn')}}</div>
                    <div>
                        <div>
                            <span :style="{'minWidth': $i18n.locale=='en'?'65px':'40px'}">{{$t('maijia.contactAdressTitle')}}</span>
                            {{$t('maijia.contactAdressDetail')}}
                        </div>
                        <div>
                            <span :style="{'minWidth': $i18n.locale=='en'?'80px':'40px'}">{{$t('maijia.contactTelTitle')}}</span>
                            {{$t('maijia.contactTelDetail')}}
                        </div>
                        <div>
                            <span :style="{'minWidth': $i18n.locale=='en'?'45px':'40px'}">{{$t('maijia.contactEmailTitle')}}</span>
                            {{$t('maijia.contactEmailDetail')}}
                        </div>
                    </div>
                    <div>
                        <img src="../assets/images/erweima.png" alt="">
                        <div>
                            <p>{{$t('maijia.contactText1')}}</p>
                            <p>{{$t('maijia.contactText2')}}</p>
                            <p>{{$t('maijia.contactText3')}}</p>
                            <p>{{$t('maijia.contactText4')}}</p>
                            <p>{{$t('maijia.contactText5')}}</p>
                        </div>
                    </div>
                    <p>{{$t('maijia.contactText6')}}</p>
                </div>
                <div class="contact_detail_right">
                    <el-amap vid="amapDemo" :zoom="zoom" :center="center">
                        <el-amap-info-window :position="mywindow.position" :content="mywindow.content" :visible="mywindow.visible" :events="mywindow.events"></el-amap-info-window>
                        <el-amap-marker :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
                    </el-amap>
                </div>
            </div>
        </div>
        <div class=" d_f_c_c" style="padding:100px 0;background-color:#FAFAFA;">
            <p style="font-size: 30px;color: #020202;padding-bottom:40px;">{{$t('maijia.partnersTitle')}}</p>
            <div style="width:1200px;">
                <el-carousel indicator-position="outside" :interval="5000" arrow="never" height="245px">
                    <el-carousel-item>
                        <img src="../assets/images/mj_partners_2.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="../assets/images/mj_partners_1_xinjiang.png" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'
import footCpright from '../components/foot-cpright.vue'
import caseItems from '../components/case-items.vue'
export default {
    data() {
        return {
            animations: 1,
            overflowAble: false,
            showAnimations: true,
            showLogo: true,
            serveImageLoad: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false
            },
            showCaseMore: true,
            caseList: [],
            placeholderName: '',
            placeholderContactWay: '',
            name: '',
            contactWay: '',
            zoom: 16,
            center: [120.25188, 30.31858],
            marker: {
                position: [120.25188, 30.31858],
                visible: true,
                draggable: true
            },
            mywindow: {
                position: [120.25188, 30.31858],
                content: '<div style="font-size:13px;">东谷创业园</div>',
                visible: true
            },
            plugin: {
                pName: "Scale",
                events: {
                    init(instance) {
                        console.log(instance);
                    }
                }
            }
        }
    },
    components: {
        maijiaHead,
        footCpright,
        caseItems
    },
    created() {
        this.handleAnimation()
        this.handleLangChange()
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            this.handleLangChange()
        }
    },
    methods: {
        go() {
            this.$router.push({ name: 'MaiJiaCaseList' })
        },
        getData() {
            this.$http.get("/site/mplus-case", {
                params: {
                    lang: this.$i18n.locale
                }
            }).then(response => {
                this.showCaseMore = response.d.Results.length > 3 ? true : false;
                this.caseList = response.d.Results.length > 3 ? response.d.Results.slice(0, 3) : response.d.Results
            });
        },
        handleAnimation() {
            setTimeout(() => {
                this.animations = 2;
                setTimeout(() => {
                    this.showLogo = false;
                    this.animations = 3;
                    setTimeout(() => {
                        this.showAnimations = false
                    }, 2000);
                }, 2000)
            }, 1000)
        },
        handleImageLoad(index) {
            this.serveImageLoad[index] = true
        },
        handleLangChange() {
            if (this.$i18n.locale == 'en') {
                this.placeholderName = 'your name'
                this.placeholderContactWay = 'contact information'
            } else {
                this.placeholderName = '您的姓名'
                this.placeholderContactWay = '您的联系方式'
            }
            this.getData()
        },
        handleSubmit() {
            const { name, contactWay } = this
            if (!name || !contactWay) {
                return false
            }
            this.$http
                .get("site/mplus-customer", {
                    params: {
                        Name: name,
                        Email: contactWay
                    }
                })
                .then(response => {
                    if (response.f > 0) {
                        this.$message.success('提交成功！')
                    } else {
                        this.$message.error(response.m)
                    }
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 100%;
    height: 100%;
    background: url("../assets/images/banner_pc_mj.png") no-repeat;
    background-position: center;
    background-size: cover;
    padding-bottom: 80px;
    position: relative;
    & > .maijia_head {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
}

.head > .head_content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.head > .head_content > p:nth-child(1) {
    font-size: 60px;
    color: #ffffff;
    padding-bottom: 46px;
}
.head > .head_content > p:nth-child(2),
.head > .head_content > p:nth-child(5) {
    font-size: 24px;
    color: #ff6d27;
    padding-bottom: 15px;
}
.head > .head_content > p:nth-child(3),
.head > .head_content > p:nth-child(4) {
    padding-bottom: 26px;
}
.head > .head_content > p:nth-child(3),
.head > .head_content > p:nth-child(4),
.head > .head_content > p:nth-child(6) {
    font-size: 22px;
    color: #ffffff;
}
.head > .head_content > p:nth-child(6) {
    line-height: 40px;
    text-align: center;
}
.head > .head_content > .down_arrow {
    width: 30px;
    height: 30px;
    border-top: 3px solid #fff;
    border-right: 3px solid #fff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transform: rotate(135deg);
    animation: dowm_arrow_animation 3s infinite;
}

.head_animation {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
}
.head_animation_logo {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
}

.head_animation_line {
    width: 2px;
    height: 100%;
    background-color: #fff;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
}

.head_animation_left,
.head_animation_right {
    width: 50%;
    height: 100%;
    position: absolute;
    background-color: #1b1b1b;
}
.head_animation_left {
    right: 0;
}
.head_animation_right {
    left: 0;
}

.serve_box {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
}

.serve_box > div {
    overflow: hidden;
}
.serve_box > div > .el-image {
    top: 0px;
}

.serve_box > div > p:nth-child(2) {
    font-size: 24px;
    color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width:230px;
    text-align:center;
}

.serve_box > div > p:nth-child(3) {
    width: 294px;
    text-align: left;
    line-height: 36px;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
    z-index: 1000;
    word-wrap: break-word;
    word-break: normal;
    // word-wrap: break-word;
}
.serve_box > div > div:nth-child(4) {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.9;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
}

.serve_box > div:hover > p:nth-child(2) {
    display: none;
}
.serve_box > div:hover > p:nth-child(3),
.serve_box > div:hover > div:nth-child(4) {
    display: block;
}

.case_item:last-child {
    margin-bottom: 60px !important;
}

.case_more {
    width: 116px;
    height: 44px;
    text-align: center;
    line-height: 46px;
    border: 1px solid #ffffff;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}

.contact {
    padding: 124px 0;
    background-image: url("../assets/images/bg_contact.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.contact_detail {
    width: 1200px;
    display: flex;
}

.contact_detail_left {
    width: 600px;
    background-color: #fff;
    padding: 73px 0 72px 134px;
    & p {
        color: #000000;
        word-break: normal;
    }
    & > p:nth-child(1) {
        width: 336px;
        font-size: 30px;
        text-align: center;
    }
    & > p:nth-child(2) {
        width: 336px;
        font-size: 18px;
        padding: 9px 0 40px;
        text-align: left;
    }
    & > input {
        width: 336px;
        height: 56px;
        background: #ebebeb;
        border-radius: 4px;
        border: none;
        font-size: 18px;
        color: #999999;
        padding-left: 18px;
    }
    & > input:nth-child(4) {
        margin: 20px 0 40px;
    }
    & > div:nth-child(5) {
        width: 336px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background: #ff6d27;
        border-radius: 4px;
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 30px;
        cursor: pointer;
    }
    & > div:nth-child(6) {
        width: 336px;
        margin-bottom: 30px;
        & > div {
            font-size: 14px;
            color: #000000;
            line-height: 30px;
            display: flex;
            align-items: flex-start;
            word-break: normal;
        }
    }

    & > div:nth-child(7) {
        width: 375px;
        display: flex;
        align-items: center;
        & > img {
            width: 156px;
            height: 156px;
            margin-right: 20px;
        }
        & > div {
            height: 134px;
            & > p {
                font-size: 14px;
                color: #000000;
                line-height: 26px;
            }
        }
    }
    & > p:nth-child(8) {
        padding-top: 10px;
        margin-left: 34px;
    }
}

.contact_detail_right {
    width: 600px;
}

.p_r {
    position: relative;
}
.p_a {
    position: absolute;
}

.bgc_w {
    background-color: #fff;
}
.bgc_b {
    background-color: #000;
}

.d_f_c_c {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.animations_opacity {
    animation: animation_opacity 1s;
}

.animations_logo {
    animation: head_show_logo 2s;
}

.animations_line {
    animation: head_show_line 2s;
}

.animations_door {
    animation: head_show_door 2s;
}

.animations_serve_image {
    animation: serve_image_animation 2s;
}
@keyframes head_show_logo {
    0% {
        top: 89%;
    }
    100% {
        top: 10%;
    }
}

@keyframes head_show_line {
    0% {
        top: 100%;
    }
    100% {
        top: 18%;
    }
}

@keyframes animation_opacity {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes head_show_door {
    0% {
        width: 50%;
    }
    100% {
        width: 0%;
    }
}

@keyframes serve_image_animation {
    0% {
        top: -322px;
    }
    100% {
        top: 0px;
    }
}

@keyframes dowm_arrow_animation {
    0% {
        bottom: 50px;
    }
    50% {
        bottom: 70px;
    }
    100% {
        bottom: 50px;
    }
}
</style>